import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull';
import { AttachmentsTestIds } from './Attachments.utils';
export const AttachmentTitle = ()=>/*#__PURE__*/ _jsx(Typography, {
        variant: "paragraph1",
        weight: "normal",
        testId: AttachmentsTestIds.Title(),
        children: "Attachments"
    });
